var _defs, _ellipse, _font, _br, _text, _ellipse2, _b, _text2, _ellipse3, _b2, _text3, _ellipse4, _b3, _text4, _ellipse5, _b4, _text5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect, _i, _br2, _text6, _rect2, _i2, _br3, _text7, _rect3, _i3, _br4, _text8, _path13, _path14, _rect4, _br5, _text9, _path15, _rect5, _font2, _text10, _path16, _rect6, _i4, _text11, _path17, _rect7, _br6, _text12, _rect8, _br7, _text13, _rect9, _b5, _text14, _switch;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEvidence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "706px",
    height: "532px",
    viewBox: "-0.5 -0.5 706 532",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2022-04-12T04:40:25.805Z\" agent=\"5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/100.0.4896.75 Safari/537.36\" etag=\"LJkLZf1SQHBOFvRtLaQt\" version=\"17.4.2\" type=\"device\"><diagram id=\"wKcBAhCuXYNdXWTdjvHx\" name=\"Page-1\">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</diagram></mxfile>",
    style: {
      backgroundColor: "rgb(255, 255, 255)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 380,
    cy: 260,
    rx: 65.5,
    ry: 65.5,
    fill: "#76608a",
    stroke: "#432d57",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 129,
      height: 1,
      paddingTop: 260,
      marginLeft: 316
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #ffffff; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      lineHeight: 1.5,
      fontSize: 14
    }
  }, _font || (_font = /*#__PURE__*/React.createElement("font", {
    color: "#ffffff"
  }, /*#__PURE__*/React.createElement("b", null, "Evidence based Lifecycle\xA0", /*#__PURE__*/React.createElement("br", null), "Management"))), _br || (_br = /*#__PURE__*/React.createElement("br", null))))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 380,
    y: 264,
    fill: "#ffffff",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Evidence based Lifecyc...")))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 385,
    cy: 130,
    rx: 50,
    ry: 50,
    fill: "#cce5ff",
    stroke: "#36393d",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 98,
      height: 1,
      paddingTop: 130,
      marginLeft: 336
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _b || (_b = /*#__PURE__*/React.createElement("b", null, "Health ", /*#__PURE__*/React.createElement("br", null), "Impact Assessment")))))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 385,
    y: 134,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "Health...")))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 525,
    cy: 260,
    rx: 50,
    ry: 50,
    fill: "#ffff88",
    stroke: "#36393d",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 98,
      height: 1,
      paddingTop: 260,
      marginLeft: 476
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _b2 || (_b2 = /*#__PURE__*/React.createElement("b", null, "Health ", /*#__PURE__*/React.createElement("br", null), "Technology Assessment")))))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 525,
    y: 264,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "Health...")))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 235,
    cy: 260,
    rx: 50,
    ry: 50,
    fill: "#ffcc99",
    stroke: "#36393d",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 98,
      height: 1,
      paddingTop: 260,
      marginLeft: 186
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _b3 || (_b3 = /*#__PURE__*/React.createElement("b", null, "Health ", /*#__PURE__*/React.createElement("br", null), "Needs Assessment")))))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 235,
    y: 264,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "Health...")))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 385,
    cy: 390,
    rx: 50,
    ry: 50,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 98,
      height: 1,
      paddingTop: 390,
      marginLeft: 336
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _b4 || (_b4 = /*#__PURE__*/React.createElement("b", null, "Health ", /*#__PURE__*/React.createElement("br", null), "Technology", /*#__PURE__*/React.createElement("br", null), "Management")))))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 385,
    y: 394,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "Health...")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 257.84 215.52 L 278.4 175.88 Q 283 167 291.81 162.27 L 337 138",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 435 390 L 495 362 L 515 310",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 335 390 L 278 353 L 259 304",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 435 141 L 491 162 L 505 210",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 175 70 L 244.56 148.26",
    fill: "none",
    stroke: "#ff0080",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 250.54 154.99 L 238.09 150 L 244.56 148.26 L 247.06 142.03 Z",
    fill: "#ff0080",
    stroke: "#ff0080",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 585 70 L 515.44 148.26",
    fill: "none",
    stroke: "#009900",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 509.46 154.99 L 512.94 142.03 L 515.44 148.26 L 521.91 150 Z",
    fill: "#009900",
    stroke: "#009900",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 606 445 L 518.27 374.81",
    fill: "none",
    stroke: "#99004d",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 511.24 369.19 L 524.36 372 L 518.27 374.81 L 516.86 381.37 Z",
    fill: "#99004d",
    stroke: "#99004d",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 174 455 L 251.33 371.52",
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 257.44 364.92 L 253.69 377.8 L 251.33 371.52 L 244.89 369.65 Z",
    fill: "#ff0000",
    stroke: "#ff0000",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 40,
    width: 90,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 60,
      marginLeft: 250
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #fff; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    color: "#000000",
    style: {
      fontSize: 14
    }
  }, _i || (_i = /*#__PURE__*/React.createElement("i", null, "Pre-clinical\xA0", /*#__PURE__*/React.createElement("br", null), "Research")), _br2 || (_br2 = /*#__PURE__*/React.createElement("br", null))))))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 64,
    fill: "#fff",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "Pre-clinical...")))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 30,
    width: 80,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 50,
      marginLeft: 505
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #fff; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    color: "#000000",
    style: {
      fontSize: 14
    }
  }, _i2 || (_i2 = /*#__PURE__*/React.createElement("i", null, "Clinical\xA0", /*#__PURE__*/React.createElement("br", null), "Research")), _br3 || (_br3 = /*#__PURE__*/React.createElement("br", null))))))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 505,
    y: 54,
    fill: "#fff",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "Clinical...")))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 575,
    y: 300,
    width: 120,
    height: 60,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 330,
      marginLeft: 635
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #fff; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    color: "#000000",
    style: {
      fontSize: 14
    }
  }, _i3 || (_i3 = /*#__PURE__*/React.createElement("i", null, "Health Services\xA0", /*#__PURE__*/React.createElement("br", null), "Related ", /*#__PURE__*/React.createElement("br", null), "Assessment")), _br4 || (_br4 = /*#__PURE__*/React.createElement("br", null))))))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 635,
    y: 334,
    fill: "#fff",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "Health Services...")))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 622 165 L 660 192.5 L 622 220 L 622 207.5 C 576.71 207.5 540 228.77 540 255 C 540 212.2 576.71 177.5 622 177.5 Z",
    fill: "#647687",
    stroke: "#314354",
    strokeMiterlimit: 10,
    transform: "rotate(90,600,210)",
    pointerEvents: "all"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 407 0 L 445 27.5 L 407 55 L 407 42.5 C 356.19 42.5 315 59.29 315 80 C 315 42.72 356.19 12.5 407 12.5 Z",
    fill: "#647687",
    stroke: "#314354",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10,
    width: 200,
    height: 60,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 40,
      marginLeft: 100
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    color: "#ff0080"
  }, /*#__PURE__*/React.createElement("b", {
    style: {
      lineHeight: 1.8
    }
  }, "Research and Development", _br5 || (_br5 = /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("span", {
    style: {
      whiteSpace: "pre"
    }
  }), "Early Dialogue")))))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 44,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "Research and Development...")))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 527 440 L 565 467.5 L 527 495 L 527 482.5 C 487.24 482.5 455 501.53 455 525 C 455 484.96 487.24 452.5 527 452.5 Z",
    fill: "#647687",
    stroke: "#314354",
    strokeMiterlimit: 10,
    transform: "rotate(180,510,482.5)",
    pointerEvents: "all"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 500,
    width: 120,
    height: 20,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 510,
      marginLeft: 390
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FF0080; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(255, 0, 128)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, _font2 || (_font2 = /*#__PURE__*/React.createElement("font", {
    color: "#000000"
  }, /*#__PURE__*/React.createElement("i", null, "Appropriate Use"))))))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 390,
    y: 514,
    fill: "#FF0080",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "Appropriate Use")))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 302 425 L 340 452.5 L 302 480 L 302 467.5 C 267.76 467.5 240 497.72 240 535 C 240 481.15 267.76 437.5 302 437.5 Z",
    fill: "#647687",
    stroke: "#314354",
    strokeMiterlimit: 10,
    transform: "rotate(270,290,480)",
    pointerEvents: "all"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 360,
    width: 80,
    height: 20,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 370,
      marginLeft: 165
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, _i4 || (_i4 = /*#__PURE__*/React.createElement("i", null, "Innovation")))))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 165,
    y: 374,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "Innovation")))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 212 175 L 250 202.5 L 212 230 L 212 217.5 C 128.05 217.5 60 243.24 60 275 C 60 226.68 128.05 187.5 212 187.5 Z",
    fill: "#647687",
    stroke: "#314354",
    strokeMiterlimit: 10,
    transform: "rotate(270,155,225)",
    pointerEvents: "all"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 545,
    y: 0,
    width: 160,
    height: 60,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 30,
      marginLeft: 625
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    color: "#009900"
  }, /*#__PURE__*/React.createElement("b", {
    style: {
      lineHeight: 1.8
    }
  }, "Regulation", _br6 || (_br6 = /*#__PURE__*/React.createElement("br", null)), "Market Authorisation")))))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 625,
    y: 34,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "Regulation...")))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 575,
    y: 450,
    width: 130,
    height: 60,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 480,
      marginLeft: 640
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    color: "#99004d"
  }, /*#__PURE__*/React.createElement("b", {
    style: {
      lineHeight: 1.8
    }
  }, "Investment", _br7 || (_br7 = /*#__PURE__*/React.createElement("br", null)), "Health Provision")))))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 484,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "Investment...")))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 465,
    width: 180,
    height: 60,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 495,
      marginLeft: 135
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #99004D; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(153, 0, 77)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    color: "#ff0000",
    style: {
      lineHeight: 1.8
    }
  }, _b5 || (_b5 = /*#__PURE__*/React.createElement("b", null, "DisInvestment", /*#__PURE__*/React.createElement("br", null), "Exclusion from provision"))))))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 499,
    fill: "#99004D",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "DisInvestment..."))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvidence);
export default __webpack_public_path__ + "static/media/evidence.b4fad52c70460997659baa2c1f6eedcf.svg";
export { ForwardRef as ReactComponent };